import React, { useState } from "react";
import {
    Button,
    Typography,
    Box,
    Modal,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    IconButton,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit'; // Import the Edit icon


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    maxHeight: 600,
    overflowY: "scroll",
    p: 4,

};

const EditButton = ({
    setRefresh,
    laptopData,
    refresh,

}) => {
    const [editData, setEditData] = useState();

    const [open, setOpen] = useState(false);

    const handleEditClick = () => {

        const currentDate = new Date().toISOString().split('T')[0];

        const SavedData = JSON.parse(localStorage.getItem('_AuthSama_'));
        const userEmail = SavedData?.[0]?.email || "Email not found";

        const lastUpdatedBy = userEmail || 'Unknown';

        setEditData({
            id: laptopData.ID || "",
            donorCompanyName: laptopData["Donor Company Name"] || "",
            ram: laptopData.RAM || "",
            rom: laptopData.ROM || "",
            manufacturerModel: laptopData["Manufacturer Model"] || "",
            processor: laptopData.Processor || "",
            macAddress: laptopData["Mac address"] || "",
            status: laptopData.Status || "",
            working: laptopData.Status === "NOT_WORKING" ? "Not Working" : (laptopData.Working || ""),
            batteryCapacity: laptopData["Battery Capacity"] || "",
            inventoryLocation: laptopData["Inventory Location"] || "",
            laptopWeight: laptopData["laptop weight"] || "",
            conditionStatus: laptopData["Condition Status"] || "",
            manufacturingDate: laptopData["Manufacturing Date"] || "",
            majorIssues: laptopData["Major Issues"] ? String(laptopData["Major Issues"]).split(",").map(issue => issue.trim()) : [],
            minorIssues: laptopData["Minor Issues"] ? String(laptopData["Minor Issues"]).split(",").map(issue => issue.trim()) : [],
            assignedTo: laptopData["Assigned To"] || "",
            donatedTo: laptopData["Allocated To"],
            lastUpdatedOn: currentDate,
            lastUpdatedBy: lastUpdatedBy,
            comment: laptopData["Comment for the Issues"],
        });
        setOpen(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setEditData((prevData) => ({
            ...prevData,
            [name]: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleSaveEdit = async () => {
        let currentStatus = editData.status || laptopData.Status;

        const dataToSend = {
            ...editData,
            status: currentStatus,
            allocatedTo: currentStatus === "NOT_WORKING" ? "" : (editData.allocatedTo || laptopData["Allocated To"]),
            assignedTo: currentStatus === "NOT_WORKING" ? "" : (editData.assignedTo || laptopData["Assigned To"]),
            type: "laptopLabeling",
        };

        const apiBase = window.location.origin.includes("localhost") || window.location.origin.includes("127.0.0.1")
            ? "http://localhost:8000"
            : "https://sama-api.thesama.in";
        const apiUrl = `${apiBase}/exec`;

        try {

            await fetch(
                apiUrl,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToSend),
                }
            );
            handleModalClose();

            // Close the modal and reset the data after successfully saving
            if (setRefresh) {
                setRefresh(!refresh);
            }
            // setRefresh(!refresh);
            setEditData(
                {
                    id: "",
                    donorCompanyName: "",
                    ram: "",
                    rom: "",
                    manufacturerModel: "",
                    processor: "",
                    macAddress: "",
                    status: "",
                    working: "",
                    batteryCapacity: "",
                    inventoryLocation: "",
                    laptopWeight: "",
                    conditionStatus: "",
                    manufacturingDate: "",
                    majorIssues: [],
                    minorIssues: [],
                    assignedTo: "",
                    donatedTo: "",
                    lastUpdatedOn: "",
                    lastUpdatedBy: "",
                    comment: "",
                }
            );

        } catch (error) {
            console.error("Error tagging the laptop:", error);
        }
    };

    const handleModalClose = () => {
        setOpen(false);
    };

    const majorIssueOptions = [
        "Fan",
        "Speaker",
        "Microphone",
        "Damaged Screen",
        "Faulty Battery",
        "Overheating",
        "Malfunctioning Keyboard",
        "Broken Ports",
        "Hard Drive Issues",
        "Defective Motherboard",
        "Audio Problems",
        "Graphics Card Issues",
        "Water Damage",
        "USB Ports",
        "Camera issue",
        "Charging point issue",
        "Fan Error",
        "Wifi issue"

    ];

    const minorIssuesOptions = [

        "Cosmetic Wear",
        "Loose Hinges",
        "Dead Pixels",
        "Fading Keyboard",
        "Small Battery Capacity Loss",
        "Minor Software Issues",
        "Port Wear",
        "Touchpad Sensitivity",
        "CMOS Battery",
        "RAM Issue",
    ];

    return (
        <>
            <IconButton
                color="primary"
                onClick={handleEditClick}
                aria-label="edit"
            >
                <EditIcon />
            </IconButton>
            <Modal open={open} onClose={handleModalClose}>
                <Box sx={style}>
                    <Typography variant="h6">Edit Laptop</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Donor Company Name"
                                name="donorCompanyName"
                                value={editData?.donorCompanyName || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>RAM</InputLabel>
                                <Select
                                    name="ram"
                                    value={editData?.ram || ""}
                                    onChange={handleEditChange}
                                    label="RAM"
                                >
                                    {["8GB", "12GB", "16GB", "24GB", "32GB"].map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>ROM</InputLabel>
                                <Select
                                    name="rom"
                                    value={editData?.rom || ""}
                                    onChange={handleEditChange}
                                    label="ROM"
                                >
                                    {["256GB", "512GB", "1TB"].map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Processor</InputLabel>
                                <Select
                                    name="processor"
                                    value={editData?.processor || ""}
                                    onChange={handleEditChange}
                                    label="Processor"
                                >
                                    {["i3", "i5", "i7", "Ryzen 3", "Ryzen 5", "Ryzen 7", "M1", "M1 Pro", "M1 Max", "M2", "M2 Pro", "M2 Max"].map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="MAC Address"
                                name="macAddress"
                                value={editData?.macAddress || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Laptop Weight"
                                name="laptopWeight"
                                value={editData?.laptopWeight || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Condition Status"
                                name="conditionStatus"
                                value={editData?.conditionStatus || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Working Status</InputLabel>
                                <Select
                                    name="working"
                                    value={editData?.working || ""}
                                    onChange={handleEditChange}
                                    label="Working Status"
                                >
                                    {["Working", "Not Working"].map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Manufacturing Date"
                                name="manufacturingDate"
                                InputLabelProps={{ shrink: true }}
                                value={editData?.manufacturingDate || ""}
                                onChange={handleEditChange}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                type="date"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Major Issues</InputLabel>
                                <Select
                                    label="Major Issues"
                                    name="majorIssues"
                                    value={editData?.majorIssues || []}
                                    multiple
                                    onChange={handleSelectChange}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {majorIssueOptions.map((option, index) => (
                                        <MenuItem key={index} value={option}>
                                            <Checkbox checked={editData?.majorIssues?.indexOf(option) > -1} />
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Minor Issues</InputLabel>
                                <Select
                                    label="Minor Issues"
                                    name="minorIssues"
                                    value={editData?.minorIssues || []}
                                    multiple
                                    onChange={handleSelectChange}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {minorIssuesOptions.map((option, index) => (
                                        <MenuItem key={index} value={option}>
                                            <Checkbox checked={editData?.minorIssues?.indexOf(option) > -1} />
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Battery Capacity"
                                name="batteryCapacity"
                                value={editData?.batteryCapacity || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Inventory Location"
                                name="inventoryLocation"
                                value={editData?.inventoryLocation || ""}
                                onChange={handleEditChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                    </Grid>
                    <Box mt={2}>
                        <Button variant="contained" color="primary" onClick={handleSaveEdit}>
                            Save
                        </Button>
                        <Button variant="outlined" color="secondary" onClick={handleModalClose} sx={{ ml: 2 }}>
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default EditButton;
